<template>
  <v-card class="card" color="white" v-bind="props">
    <v-img :aspect-ratio="11 / 9" :src="Itemdata.foto" cover>
      <v-expand-transition>
        <div
          v-if="isHovering"
          class="d-flex transition-fast-in-fast-out bg-orange-darken-2 v-card--reveal text-h2"
          style="height: 100%"
        >
          - {{ descuento }}%
        </div>
      </v-expand-transition>
    </v-img>

    <v-card-text class="pt-6">
      <p
        class="text-h6 font-weight-light text-orange mb-2"
        style="
          color: #1c3e8e;
          font-family: Arial, Helvetica, sans-serif;
          font-size: larger;
          padding: 10px;
        "
      >
        {{ DescripcionTruncado }}
      </p>
      <div class="font-weight-light text-h6 d-flex justify-content-start">
        <p style="font-family: Arial, Helvetica, sans-serif; font-size: small">
          Antes: $ <span class="rayado">{{ Itemdata.precio2 }} MXN </span>
          <span style="color: green">. -{{ descuento }}%</span>
        </p>
      </div>
      <div class="d-flex justify-content-start">
        <p style="font-family: Arial, Helvetica, sans-serif; font-size: large">
          Ahora:
          <span style="color: green"> $ {{ precio2ConDescuento }}</span>
        </p>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn block variant="outlined" color="green" @click="AgregarAlCarro">
        COTIZAR
      </v-btn>

      <v-dialog v-model="dialog" width="auto">
        <v-card max-width="600">
          <v-toolbar color="blue" title="Se añadio al carrito"> </v-toolbar>
          <div align="center">
            <v-img alt="" :src="Itemdata.foto" height="200" width="250" />
            <p>{{ Itemdata.descripcion }}</p>
          </div>

          <div align="center">
            <v-img
              alt=""
              height="100"
              :src="require('@/assets/icons8-success.gif')"
            />
            <v-btn variant="tonal" color="blue" to="/carrito"
              >Ir al Crrito</v-btn
            >
          </div>
          <template v-slot:actions>
            <v-btn
              class="ms-auto"
              text="Seguir viendo"
              @click="dialog = false"
            ></v-btn>
          </template>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    Itemdata: {
      id: {
        type: String,
        default: '',
      },
      codigo: {
        type: String,
        default: '',
      },
      descripcion: {
        type: String,
        default: '',
      },
      precio1: {
        type: String,
        default: '',
      },
      precio2: {
        type: String,
        default: '',
      },
      clasificacion: {
        type: String,
        default: '',
      },
      categoriaOferta: {
        type: String,
        default: '',
      },
      estatus: {
        type: String,
        default: '',
      },
      foto: {
        type: String,
        default: '',
      },
    },
    descuento: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
    };
  },
  mounted() {},

  methods: {
    ...mapActions('cartProduct', ['addToCartProduct']),

    AgregarAlCarro() {
      try {
        this.loading = true;

        var newProduct = {
          codigo: this.Itemdata.codigo,
          descripcion: this.Itemdata.descripcion,
          precio1: this.Itemdata.precio1,
          precio2: this.precio2ConDescuento,
          clasificacion: this.Itemdata.clasificacion,
          claveClasifica: this.Itemdata.categoriaOferta,
          cantidad: 1,
        };
        this.addToCartProduct(newProduct);

        this.dialog = true;
      } catch (error) {}
    },
  },
  computed: {
    precio2ConDescuento() {
      return (
        parseFloat(this.Itemdata.precio2) *
        (1 - parseFloat(this.descuento) / 100)
      );
    },
    DescripcionTruncado() {
      const limite = 45;
      if (this.Itemdata.descripcion.length > limite) {
        return this.Itemdata.descripcion.substring(0, limite) + '...';
      } else {
        return this.Itemdata.descripcion;
      }
    },
    CategoriaTruncado() {
      const limite = 21;
      if (this.Itemdata.clasificacion.length > limite) {
        return this.Itemdata.clasificacion.substring(0, limite) + '...';
      } else {
        return this.Itemdata.clasificacion;
      }
    },
  },
  watch: {
    loading(val) {
      if (!val) return;

      setTimeout(() => (this.loading = false), 2500);
    },
  },
};
</script>

<style scoped>
.card {
  flex: none;
  width: 250px;
  height: 470px;
  margin: 30px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: center;
  line-height: 300px;
}
.rayado {
  text-decoration: line-through;
}
</style>
